/**
 * @format
 * @flow
 */

import {
  UPDATE_SETTINGS,
  UPDATE_DELIVERY_SCHEDULE,
  UPDATE_ORDER_SCHEDULE,
  UPDATE_DELIVERY_SETTINGS,
  UPDATE_TAKEAWAY_SETTINGS,
  UPDATE_MENU_SETTINGS,
  SET_LANGUAGE
} from '../actions/settingsAction';
import { SettingsType } from '../flowObjectType'
import { getStoredLang } from '../utils/translations'

const settingsObject: SettingsType = {
  id: '',
  color: '',
  autoAcceptOrder: false,
  delivery: false,
  takeaway: true,
  table: false,
  deliverySettings: {},
  takeawaySettings: {},
  stripe: {},
  orderTypePopup: false,
  sharedCart: false,
  currencySymbol: '€',
  productComments: false,
  languages: null,
  lang: getStoredLang()
}

export default function foo(state: Object = { ...settingsObject }, action: Object) {
  switch (action.type) {
    case UPDATE_SETTINGS:
      return {
        ...state,
        id: action.payload.id,
        color: action.payload.color,
        autoAcceptOrder: action.payload.autoAcceptOrder,
        delivery: action.payload.delivery,
        takeaway: action.payload.takeaway,
        table: action.payload.table,
        stripe: action.payload.stripe,
        orderTypePopup: action.payload.orderTypePopup,
        sharedCart: action.payload.sharedCart,
        // Devise masquée (showCurrencyOnOrder = false) : symbole vide, formatCurrency n'affiche que le montant
        currencySymbol: action.payload.showCurrency === false ? '' : (action.payload.currencySymbol || '€')
      }
    case UPDATE_ORDER_SCHEDULE:
      return { ...state, orderSchedule: action.payload.orderSchedule };
    case UPDATE_DELIVERY_SCHEDULE:
      return { ...state, deliverySchedule: action.payload.deliverySchedule };
    case UPDATE_DELIVERY_SETTINGS:
      return { ...state, deliverySettings: action.payload.deliverySettings };
    case UPDATE_TAKEAWAY_SETTINGS:
      return { ...state, takeawaySettings: action.payload.takeawaySettings };
    case UPDATE_MENU_SETTINGS:
      return { ...state, productComments: action.payload.productComments, languages: action.payload.languages };
    case SET_LANGUAGE:
      return { ...state, lang: action.payload.lang };
    default:
      return state;
  }
}
